import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UserPermissionToVideoRecordRole } from '@distribute/shared/types';
import {
  DEFAULT_RATIO,
  getMuxImage,
  getMuxStream,
} from '@distribute/shared/utils';

import { VideoCard } from '../../../../../entities/video';
import {
  checkIsRecordConverting,
  checkIsRecordConvertingFailed,
} from '../../../lib';
import { recordingsModel } from '../../../model';
import { RecordTitle } from './RecordTitle';

export const RecordContent: FC = () => {
  const {
    playbackId,
    status,
    statusConvert,
    createdAt,
    userPermissionToVideoRecords,
    metadata,
  } = useSelector(recordingsModel.selectors.selectRecord);

  const owner = userPermissionToVideoRecords.find(
    (uV) => uV.role === UserPermissionToVideoRecordRole.OWNER
  );

  const video = useMemo(() => {
    return {
      isLoading: checkIsRecordConverting(statusConvert),
      isFailed: checkIsRecordConvertingFailed({ status, statusConvert }),
      url: getMuxStream(playbackId || ''),
      posterUrl: getMuxImage(playbackId || ''),
      aspectRatio: metadata?.mux?.aspectRatio || DEFAULT_RATIO,
    };
  }, [status, statusConvert, playbackId, metadata]);

  return (
    <div className="flex flex-col p-8 sm:p-0 sm:py-5">
      <div className="mx-auto max-w-240 w-full">
        <VideoCard
          Title={<RecordTitle />}
          createdAt={createdAt}
          displayName={owner?.user?.displayName || ''}
          photoUrl={owner?.user?.photoUrl || ''}
          video={video}
        />
      </div>
    </div>
  );
};
